import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';
import UserSvg from '@/assets/User.svg';

const User = ({ size, variant, className }: IconProps) => (
  <img
    src={UserSvg}
    className={cn(iconVariant({ variant, size, className }))}
    aria-hidden="true"
    alt=""
  />
);

export default User;
